const state = {
  setList: []
}

const mutations = {
  ADD_LIST: (state, log) => {
    state.setList.push(log)
  },
  DELETE_LIST: (state, newList) => {
    // state.setList.splice(index, 1)
    state.setList = JSON.parse(JSON.stringify(newList))
  },
  UPDATE_LIST: (state, newList) => {
    // 替换
    state.setList = JSON.parse(JSON.stringify(newList))
  },
  CLEAR_LIST: (state) => {
    state.setList.splice(0)
  }
}

const actions = {
  addSettingList({ commit }, log) {
    commit('ADD_LIST', log)
  },
  deleteSettingList({ commit }, newList) {
    commit('DELETE_LIST', newList)
  },
  updateSettingList({ commit }, newList) {
    commit('UPDATE_LIST', newList)
  },
  clearSettingList({ commit }) {
    commit('CLEAR_LIST')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
